import {Alert, Button, Col, Form, Row} from "react-bootstrap";
import {FormEvent, useMemo, useState} from "react";
import {LinearProgress} from "@mui/material";
import { IdentifierTypeEnum, parseIdentifier } from "../Behaviors/identifier";

export interface Props {
    visible: boolean
    onUpcPicked: (upc: string) => void;
    loading: boolean;
    errorMessage: string
}

export const UpcPicker = (props: Props) => {
    const apiErrorMessage = useMemo(() => props.errorMessage, [props]);
    const [errorMessage, setErrorMessage] = useState("");

    async function handleSubmit(event: FormEvent) {

        event.preventDefault();
        event.stopPropagation();

        const target = event.target as unknown as { upc: { value: string } };
        const text = target.upc.value.trim();

        const identifierType = parseIdentifier(text);

        if (identifierType === IdentifierTypeEnum.Unknown) {
            setErrorMessage("Identifier must be a 14 digit UPC, or a 12 character ISRC.");
            return;
        }

        setErrorMessage("");
        props.onUpcPicked(text);
    }

    if (props.visible) {
        if (props.loading) {
            return (
                <Form onSubmit={handleSubmit} className={"m-3"}>
                    <Row className="align-items-center">
                        <Col className="align-items-center">

                            <LinearProgress />
                        </Col>
                        <Col xs="auto">
                            <Button disabled={true} type="submit" className="mb-4">
                                Loading...
                            </Button>
                        </Col>
                    </Row>
                </Form>
            );
        }
        return (
            <Form autoComplete="off" onSubmit={handleSubmit}>
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={2} className={"col-form-label"}>Identifier</Form.Label>
                    <Col lg={5}>
                        <Form.Control name="upc" defaultValue={""}
                            maxLength = {14}
                            aria-label={"identfier"}
                            placeholder={"UPC or ISRC"} isValid={errorMessage === ""}
                            isInvalid={errorMessage !== ""}
                        />
                        <Form.Control.Feedback aria-label="Identifier Error Feedback" type="invalid">
                            {errorMessage}
                        </Form.Control.Feedback>
                    </Col>
                    <Col lg={3}>
                        <Button aria-label={"submit"} type="submit" className="mb-4">
                            Submit
                        </Button>
                    </Col>
                </Form.Group>
                <Row>
                    <Col>
                        {apiErrorMessage === "" ? null :
                            <Alert aria-label={"Identifier Error Message"} variant="danger"> {apiErrorMessage}</Alert>}
                    </Col>
                </Row>
            </Form>
        );
    } else return null;
};
